// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"47d9b892","732":"93726d89"}[chunkId] + ".chunk.js";
};